import React from "react";
import "./ForgotPassword.scss";
import Logo from "../../assets/success.png";
import Logo_Banner from "../../assets/logo_banner.png";
import { useNavigate } from "react-router-dom";
function PasswordReset() {
  let navigate = useNavigate();
  return (
    <div className="grid">
      <div className="order__left centered">
        <div className="form">
          <img
            className="success_logo centered"
            src={Logo}
            alt="astrocure_logo"
          />
          <p className="success-header-text">Success !</p>
          <p className="forgot-description-text-success">
            Your password has been changed successfully use your new password to
            log in.
          </p>
          <button
            type="submit"
            class="send_otp login-text"
            onClick={() => navigate("/")}
          >
            Back to Login Page
          </button>
          <div class="signups">
            <label className="remember_me">Copyright © 2024</label>
            <span class="forgot__password">
              <strong>Astrovidhi Private Limited</strong>{" "}
            </span>{" "}
            <label className="remember_me"> All rights reserved</label>
          </div>
        </div>
      </div>
      <div className="order__right no__overflow banner">
        <img className="banner__image" src={Logo_Banner} alt="banner" />
      </div>
    </div>
  );
}

export default PasswordReset;
